import { PaymentStatus } from './PaymentStatus';
export var LBFileType;
(function (LBFileType) {
    LBFileType["AR"] = "AR";
    LBFileType["Images"] = "Images";
    LBFileType["Returns"] = "Returns";
    LBFileType["Settlement"] = "Settlement";
})(LBFileType || (LBFileType = {}));
export const LockboxReturnCodes = {
    A: 'NSF',
    B: 'Uncollected Fund',
    D: 'Closed Account',
    E: 'Unable to Locate Account',
    F: 'Frozen/Blocked Account',
    R: 'Branch/Account Sold (Wrong Bank)',
    C: 'Stop Payment',
    G: 'Stale Dated',
    M: 'Non-Cash Item',
    N: 'Altered/Fictitious',
    P: 'Item Exceed Dollar Limit',
    Q: 'Non Authorized',
    T: 'Stop Payment Suspect',
    U: 'Unusable Image',
    V: 'Image Fails Security Check',
    W: 'Cannot Determine Amount',
    Y: 'Duplicate Presentment',
    Z: 'Forgery',
    H: 'Post Dated',
    I: 'Endorsement Missing',
    J: 'Endorsement Irregular',
    K: 'Signature Missing',
    L: 'Signature Irregular',
    O: 'Unable to Process',
    S: 'Refer to Maker',
    X: 'Refer to Image',
    EE: 'Edited', // ran out of letters
};
// Mapping LockboxReturnCodes to PaymentStatus
// Amy said we can leave only the top 2 as NSF for now, everything else is chargeback
export const lockboxReturnCodeToPaymentStatus = {
    A: PaymentStatus.NSF,
    B: PaymentStatus.NSF,
    D: PaymentStatus.CHARGEBACK,
    E: PaymentStatus.CHARGEBACK,
    F: PaymentStatus.CHARGEBACK,
    R: PaymentStatus.CHARGEBACK,
    C: PaymentStatus.CHARGEBACK,
    G: PaymentStatus.CHARGEBACK,
    M: PaymentStatus.CHARGEBACK,
    N: PaymentStatus.CHARGEBACK,
    P: PaymentStatus.CHARGEBACK,
    Q: PaymentStatus.CHARGEBACK,
    T: PaymentStatus.CHARGEBACK,
    U: PaymentStatus.CHARGEBACK,
    V: PaymentStatus.CHARGEBACK,
    W: PaymentStatus.CHARGEBACK,
    Y: PaymentStatus.CHARGEBACK,
    Z: PaymentStatus.CHARGEBACK,
    H: PaymentStatus.CHARGEBACK,
    I: PaymentStatus.CHARGEBACK,
    J: PaymentStatus.CHARGEBACK,
    K: PaymentStatus.CHARGEBACK,
    L: PaymentStatus.CHARGEBACK,
    O: PaymentStatus.CHARGEBACK,
    S: PaymentStatus.CHARGEBACK,
    X: PaymentStatus.CHARGEBACK,
    EE: PaymentStatus.CHARGEBACK, // New edited chargeback
};
//# sourceMappingURL=lockbox.js.map